import { Directive } from '@angular/core';

@Directive({
  selector: '[codemiroPageLayoutHeader],codemiro-page-layout-header',
  host: {
    class: 'codemiro-page-layout-header'
  }
})
export class PageLayoutHeaderDirective {

  constructor() { }

}

